<template>
  <div class="bind-info">
    <div class="bind-text1">您正在对VIN码为{{ params.vin }}的车</div>
    <div v-if="type === 'rebind'">
      <div class="bind-text2">进行ICCID卡绑定操作</div>
      <img :src="rebindImg" alt="" class="bind-img">
      <div class="bind-text3">绑定后将恢复相应的流量服务请输入验证码进行确认</div>
    </div>
    <div v-if="type === 'unbound'">
      <div class="bind-text2">进行解绑操作</div>
      <img :src="unbindImg" alt="" class="bind-img">
      <div class="bind-text1 mb12">解绑如下卡号：{{ params.iccid }}</div>
      <div class="bind-text3">解绑后该车将无法享受我们提供的联网服务，请谨慎操作，并确认您对该车的所属权。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BindInfo',
  props: {
    type: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rebindImg: require('@/assets/images/rebind.png'),
      unbindImg: require('@/assets/images/unbound.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-info {
  padding-top: 70px;
  .bind-text1 {
    font-size: 32px;
    color: #242424;
    text-align: center;
    line-height: 45px;
    font-weight: 400;
  }
  .bind-text2 {
    font-size: 32px;
    color: #242424;
    text-align: center;
    line-height: 45px;
    font-weight: 600;
  }
  .bind-text3 {
    width: 638px;
    font-size: 20px;
    color: #242424;
    text-align: center;
    font-weight: 400;
    opacity: 0.4;
    margin: 0 auto 40px;
  }
  .bind-img {
    display: block;
    width: 648px;
    height: 349px;
    margin: 84px auto 20px;
  }
  .mb12 {
    margin-bottom: 12px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/bind/components/bind-info.vue